import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';

const Box = ({
  children,
  center,
}) => (
  <div className={cx('box', {
    'box--center': center,
  })}>
    {children}
  </div>
);

Box.propTypes = {
  children: PropTypes.node.isRequired,
  center: PropTypes.bool,
};

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box/index.js